import { createContext, useState, useContext } from "react";

const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
    const [bookingCode, setBookingCode] = useState(null);

    const [bookingData, setBookingData] = useState({
        selectedCity: null,
        checkInDate: "",
        checkOutDate: "",
        rooms: "1",
        adults: "2",
        children: "0",
    });

    return (
        <BookingContext.Provider value={{ bookingData, setBookingData, bookingCode, setBookingCode }}>
            {children}
        </BookingContext.Provider>
    );
};

export const useBooking = () => useContext(BookingContext);
